import MapProctorService from './mapProctorService';

export interface AssignMapProctorTestRequest {
  test_key: string;
  student_id: string;
  targetProctor: string;
}

export interface AssignMapProctorTestResult {
  success: boolean;
  error?: string;
}

export async function assignMapProctorTest(
  input: AssignMapProctorTestRequest
): Promise<AssignMapProctorTestResult> {
  try {
    const mapProctorService = MapProctorService.getInstance();
    return await mapProctorService.assignTest(input);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
